module.exports = __webpack_public_path__ + "img/banner_mobile_KR.59d6bd86.png";